import React, { useState } from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import { STEAMER_DRIFTER_FILTER_FAVOURITE, STEAMER_DRIFTER_FILTER_DRIFTER_LOW_LIMIT, 
  STEAMER_DRIFTER_FILTER_STEAMER_LOW_LIMIT,STEAMER_DRIFTER_FILTER_DRIFTER_UPPER_LIMIT, 
  STEAMER_DRIFTER_FILTER_STEAMER_UPPER_LIMIT,
  STEAMER_DRIFTER_FILTER_COMPLETED,
  STEAMER_DRIFTER_FILTER_INCLUDE_HARNESS} from "./constants/action-types";
import { connect } from "react-redux";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

function SteamerDrifterFilterForm({ isFav, setIsFav, isCompleted, setIsCompleted,
  includeHarness, setIncludeHarness, 
  steamerLowerLimit, setSteamerLowerLimit, steamerUpperLimit, setSteamerUpperLimit,
  drifterLowerLimit, setDrifterLowerLimit, drifterUpperLimit, setDrifterUpperLimit,
  selectedDate
}) {
  const formattedDate = selectedDate.slice(0, 4) + "/" + selectedDate.slice(4, 6) + "/" + selectedDate.slice(6, 8);

  return (
    <Card className="shadow-sm border-0 p-3 rounded-4 bg-light">
      <Form style={{marginRight:"50px"}}>
        <Row style={{float:"right", color: "blue", fontSize:"x-small", fontWeight:"500", 
          margin: "1px", padding: "1px"
        }} 
        className="align-items-center justify-content-start gx-4 gy-2">
          {/* Title on the left */}
           <Col xs="auto" style={{margin: "2px", padding: "2px"}}>
            <h5 className="mb-0 fw-semibold">Steamer Drifter for: 
               {"               "} {formattedDate}</h5>
          </Col>
          <Col xs="auto" style={{margin: "2px", padding: "2px"}}>
            <h6 className="mb-0 fw-semibold">Filter Options:</h6>
          </Col>
          <Col xs="auto" style={{margin: "2px", padding: "2px"}}>
            <Form.Check
              type="checkbox"
              label="Include Harness"
              checked={includeHarness}
              onChange={(e) => setIncludeHarness(e.target.checked)}
              className="large-checkbox"
            />
          </Col>
          
          <Col xs="auto" style={{margin: "2px", padding: "2px"}}>
            <Form.Check
              type="checkbox"
              label="Show Completed"
              checked={isCompleted}
              onChange={(e) => setIsCompleted(e.target.checked)}
              className="large-checkbox"
            />
          </Col>

          {/* Checkbox 2 */}
          <Col xs="auto" style={{margin: "1px", padding: "1px"}}>
            <Form.Check
              type="checkbox"
              label="Show Favorite Only"
              checked={isFav}
              onChange={(e) => setIsFav(e.target.checked)}
              className="large-checkbox"
            />
          </Col>

          {/* Steamer Input */}
          <Col xs="auto" style={{margin: "1px", padding: "1px"}}>
            <Form.Group controlId="num1" className="mb-0 d-flex align-items-center">
              <Form.Label className="form-check-labelme-2 mb-0">Steamed greater than</Form.Label>
              <Form.Control
                type="number"
                min="0" 
                max="100" 
                value={steamerLowerLimit}
                onChange={(e) => setSteamerLowerLimit(e.target.value)}
                size="sm"
                style={{ width: "80px" }}
              />
              <Form.Label className="form-check-labelme-2 mb-0">% and less than</Form.Label>
              <Form.Control
                type="number"
                min="0" 
                max="100" 
                value={steamerUpperLimit}
                onChange={(e) => setSteamerUpperLimit(e.target.value)}
                size="sm"
                style={{ width: "80px" }}
                />
                <Form.Label className="form-check-labelme-2 mb-0">%</Form.Label>
            </Form.Group>
          </Col>

          {/* Drifter Input */}
          <Col xs="auto" style={{margin: "1px", padding: "1px"}}>
            <Form.Group controlId="num2" className="mb-0 d-flex align-items-center">
              <Form.Label className="me-2 mb-0">Drifter greater than</Form.Label>
              <Form.Control
                type="number"
                value={drifterLowerLimit}
                onChange={(e) => setDrifterLowerLimit(e.target.value)}
                size="sm"
                min="0" 
                max="100" 
                style={{ width: "80px" }}
              />
              <Form.Label className="form-check-labelme-2 mb-0">% and less than</Form.Label>
              <Form.Control
                type="number"
                min="0" 
                max="100" 
                value={drifterUpperLimit}
                onChange={(e) => setDrifterUpperLimit(e.target.value)}
                size="sm"
                style={{ width: "80px" }}
                />
                <Form.Label className="form-check-labelme-2 mb-0">%</Form.Label>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

const mapStateToProps = state => {
  return {
    isFav: state.streamerDrifterFilterSettings.isFav,
    isCompleted: state.streamerDrifterFilterSettings.isCompleted,
    steamerLowerLimit: state.streamerDrifterFilterSettings.steamerLowerLimit,
    drifterLowerLimit: state.streamerDrifterFilterSettings.drifterLowerLimit,
    steamerUpperLimit: state.streamerDrifterFilterSettings.steamerUpperLimit,
    drifterUpperLimit: state.streamerDrifterFilterSettings.drifterUpperLimit,
    includeHarness: state.streamerDrifterFilterSettings.includeHarness,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setIsFav: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_FAVOURITE, payload: payload }),
    setIsCompleted: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_COMPLETED, payload: payload }),
    setSteamerLowerLimit: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_STEAMER_LOW_LIMIT, payload: payload }),
    setDrifterLowerLimit: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_DRIFTER_LOW_LIMIT, payload: payload }),
    setSteamerUpperLimit: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_STEAMER_UPPER_LIMIT, payload: payload }),
    setDrifterUpperLimit: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_DRIFTER_UPPER_LIMIT, payload: payload }),
    setIncludeHarness: payload =>
      dispatch({ type: STEAMER_DRIFTER_FILTER_INCLUDE_HARNESS, payload: payload }),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SteamerDrifterFilterForm);
